'use client';

import React, { createContext, useContext } from 'react';

export interface ProductCategoryItem {
  id: number;
  name: string;
  slug: string;
  type?: string;
  search_tab_title?: string;
  search_tab_icon?: string;
}

export interface ProductCategoriesContextValue {
  categories: ProductCategoryItem[];
}

const ProductCategoriesContext = createContext<ProductCategoriesContextValue | undefined>(undefined);

export interface ProductCategoriesProviderProps {
  children: React.ReactNode;
  initialCategories: ProductCategoryItem[];
}

/**
 * Layout'ta bir kez alınan ana kategoriler (search tab'lar); tekrarlayan /api/product-categories istekleri kalkar.
 */
export function ProductCategoriesProvider({ children, initialCategories }: ProductCategoriesProviderProps) {
  const value: ProductCategoriesContextValue = {
    categories: initialCategories ?? [],
  };
  return (
    <ProductCategoriesContext.Provider value={value}>
      {children}
    </ProductCategoriesContext.Provider>
  );
}

export function useProductCategories(): ProductCategoryItem[] {
  const ctx = useContext(ProductCategoriesContext);
  return ctx?.categories ?? [];
}

export function useProductCategoriesContext(): ProductCategoriesContextValue {
  const ctx = useContext(ProductCategoriesContext);
  if (ctx === undefined) {
    return { categories: [] };
  }
  return ctx;
}
